import { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { FlightStatus } from 'components';
import { FlightStatusContext } from 'context';
import {
  Container,
  Head,
  Heading,
  Share,
  HeadWrapper,
  Date,
} from './Header.style';

const Header = ({ flight }) => {
  const { t } = useTranslation();
  const {
    state: { modal },
  } = useContext(FlightStatusContext);

  const handleShare = useCallback(() => {
    if (navigator.share) {
      navigator
        .share({
          title: 'SAS FLIGHT STATUS',
          url: window.location.href + `&flight=${modal.id}`,
        })
        .then(() => {
          console.log('Thanks for sharing!');
        })
        .catch(console.error);
    }
  }, [modal]);

  return (
    <Container>
      <HeadWrapper>
        <Head>
          <Heading variant="h5" color="primary">
            {t('flightstatus.details.h1')}
          </Heading>
          <FlightStatus
            statusInfo={flight?.statusInfo}
            operated={flight?.operatedBy}
          />
        </Head>
        <Date>{moment(flight?.departureDate.dateLocal).format('ll')}</Date>
      </HeadWrapper>
      <Share onClick={handleShare}>{t('flightstatus.details.share')}</Share>
    </Container>
  );
};

export default Header;
